/** 로그인 페이지로 보낼 때 한 번만 보여 줄 안내(401·세션 무효 등) */

export const LOGIN_REDIRECT_NOTICE_KEY = 'ai_cctv_login_notice';

export const LOGIN_SESSION_WALL =
  '인증이 만료되었거나 유효하지 않습니다. 다시 로그인해 주세요.';

export function setLoginRedirectNotice(message: string = LOGIN_SESSION_WALL): void {
  try {
    sessionStorage.setItem(LOGIN_REDIRECT_NOTICE_KEY, message);
  } catch {
    /* private mode 등 */
  }
}

export function consumeLoginRedirectNotice(): string | null {
  try {
    const v = sessionStorage.getItem(LOGIN_REDIRECT_NOTICE_KEY);
    if (v) {
      sessionStorage.removeItem(LOGIN_REDIRECT_NOTICE_KEY);
    }
    return v;
  } catch {
    return null;
  }
}
